/**
 * categoria-dots.js
 * ---------------------------------------------------------------------------
 * Acompanha o scroll horizontal do carrossel de Categoria (mobile) e acende
 * o dot correspondente ao slide mais visível — sem dependências externas.
 * ---------------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-categoria-dots]').forEach(function (dotsWrapper) {
    var sectionId = dotsWrapper.getAttribute('data-categoria-dots');
    var section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;

    var slides = section.querySelectorAll('.slider__slide');
    var dots = dotsWrapper.querySelectorAll('.categoria-dots__dot');
    var slider = section.querySelector('.slider');
    if (!slides.length || !dots.length || !slider) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = Array.prototype.indexOf.call(slides, entry.target);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('active', i === index);
            });
          }
        });
      },
      { root: slider, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });
});